import * as JSZip from 'jszip'
import * as moment from 'moment'
import { component } from 'vue-tsx-support'

import HeaderBar from '@/components/HeaderBar'

import * as Export from '@/export'

import grocery from '@/store/modules/grocery'

export default component({
	name: 'ExportPage',
	computed: {
		brandCount(): number {
			return grocery.brands.length
		},
		categoryCount(): number {
			return grocery.categories.length
		},
		listCount(): number {
			return grocery.lists.length
		},
		pantryItemCount(): number {
			return grocery.pantryItems.length
		},
		shoppingListItemCount(): number {
			return grocery.shoppingListItems.length
		},
	},
	methods: {
		createExportZip(): JSZip {
			const e = Export.V1.serialize(grocery)
			return new JSZip().file('export.json', JSON.stringify(e))
		},
		async exportCategories(): Promise<void> {
			const now = moment()
			const zip = this.createExportZip()
			const filename = `stock-up-export_${now.format('YYYY-MM-DD')}.zip`

			download(filename, 'application/zip;base64', await zip.generateAsync({
				compression: 'DEFLATE',
				type: 'base64',
			}))
		},
	},
	render() {
		return (
			<div>
				<HeaderBar title="Export">
					<div class="right menu">
						<div class="icon link item" onClick={this.exportCategories}>
							<i class="cloud download icon" />
						</div>
					</div>
				</HeaderBar>
				<div class="ui container">
					<table class="ui celled definition table">
						<thead>
							<tr>
								<th></th>
								<th class="right aligned">Count</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Brands</td>
								<td class="right aligned">{this.brandCount.toLocaleString()}</td>
							</tr>
							<tr>
								<td>Categories</td>
								<td class="right aligned">{this.categoryCount.toLocaleString()}</td>
							</tr>
							<tr>
								<td>Lists</td>
								<td class="right aligned">{this.listCount.toLocaleString()}</td>
							</tr>
							<tr>
								<td>Pantry Items</td>
								<td class="right aligned">{this.pantryItemCount.toLocaleString()}</td>
							</tr>
							<tr>
								<td>Shopping List Items</td>
								<td class="right aligned">{this.shoppingListItemCount.toLocaleString()}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		)
	},
})

function download(filename: string, mimeType: string, contents: string): void {
	const element = document.createElement('a')

	element.setAttribute('href', `data:${mimeType},${encodeURIComponent(contents)}`)
	element.setAttribute('download', filename)

	element.style.display = 'none'

	document.body.appendChild(element)
	element.click()
	document.body.removeChild(element)
}
